import { em } from 'polished'
import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.mineShaft};
  padding-bottom: ${em(60)};
`
